import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CalorieFriendComponent } from './calorie-friend.component';

import { PatientsComponent } from './Patients/patients.component';
import { PatientComponent } from './Patient/patient.component';

import { GoalListComponent } from './Goals/GoalList/goal-list.component';
import { GoalDefComponent } from './Goals/GoalDef/goal-def.component';
import { GoalFormResolverModule } from './Goals/goal-form-resolver.module';

import { SectionLayoutComponent } from './Patients/SectionLayout/section-layout.component';
import { PatientSheetViewComponent } from './PatientSheetView/patient-sheet-view.component';

import { MealViewerComponent } from './Plans/Viewer/View/meal-viewer.component';
import {
  EditMealPlanDefComponent,
  AddMealPlanDefComponent,
  MealPlanDefComponent,
} from './Plans/PlanDef/plan-def.component';

import { AuthGuard } from '../../@auth/guards/auth.guard';
import { PendingChangesGuard } from 'app/@auth/guards/changes.guard';
import { InitialFormGuard } from 'app/@auth/guards/initial-form.guard';
import { SubscriptionPlanComponent } from './SubscriptionPlan/subscription-plan.component';
import {
  AddFitnessPlanDefComponent,
  EditFitnessPlanDefComponent,
  FitnessPlanDefComponent,
} from './FitnessPlans/PlanDef/fitness-plan-def.component';
import { FitnessPlanTemplatesComponent } from './Plans/fitness-plan-templates/templates.component';
import { FitnessPlanTemplateResolver } from './Plans/fitness-plan-templates/template.resolver';
import { CustomExerciseListComponent } from './custom-exercise/exercise-list/exercise-list.component';
import { MealPlanTemplateResolver } from './Plans/meal-plan-templates/template.resolver';
import { MealPlanTemplatesComponent } from './Plans/meal-plan-templates/templates.component';
import { CustomFoodsComponent } from './custom-foods/custom-foods.component';
import { BrandComponent } from './brand/brand.component';
import { HelpGuidesComponent } from './help-guides/help-guides.component';
import { BillingComponent } from './billing/billing.component';
import { ProgramTemplatesComponents } from './program-templates/program-templates.component';
import { ProgramTemplateEditComponent } from './program-templates/program-template-edit/program-template-edit.component';
import { AssessmentSettingComponent } from './assessmentSetting/assessmentSetting.component';

const routes: Routes = [
  {
    path: '',
    component: CalorieFriendComponent,
    children: [
      {
        canActivate: [AuthGuard, InitialFormGuard],
        path: '',
        redirectTo: 'Patients',
        pathMatch: 'full',
      },
      {
        canActivate: [AuthGuard],
        path: 'Patients',
        component: PatientsComponent,
      },
      {
        canActivate: [AuthGuard, InitialFormGuard],
        canDeactivate: [PendingChangesGuard],
        path: 'NewPatient',
        component: PatientComponent,
      },
      {
        canActivate: [AuthGuard, InitialFormGuard],
        canDeactivate: [PendingChangesGuard],
        path: 'NewPatient/FromTutorial',
        component: PatientComponent,
      },
      {
        canActivate: [AuthGuard, InitialFormGuard],
        path: 'Patient/:id',
        component: PatientComponent,
      },
      {
        canActivate: [AuthGuard, InitialFormGuard],
        canDeactivate: [PendingChangesGuard],
        path: 'PatientSheetView/:PatientId',
        component: PatientSheetViewComponent,
      },
      {
        canActivate: [AuthGuard, InitialFormGuard],
        canDeactivate: [PendingChangesGuard],
        path: 'PatientSheetView/:PatientId/FromTutorial',
        component: PatientSheetViewComponent,
      },
      {
        canActivate: [AuthGuard, InitialFormGuard],
        path: 'Goals/:PatientId',
        component: GoalListComponent,
      },
      {
        canActivate: [AuthGuard, InitialFormGuard],
        path: 'NewGoal/:PatientId',
        component: GoalDefComponent,
      },
      {
        canActivate: [AuthGuard, InitialFormGuard],
        path: 'Goal/:PatientId/:ID',
        component: GoalDefComponent,
      },
      {
        canActivate: [AuthGuard, InitialFormGuard],
        path: 'PlanList/:PatientId',
        component: SectionLayoutComponent,
      },
      {
        canActivate: [AuthGuard, InitialFormGuard],
        path: 'my-food',
        component: CustomFoodsComponent,
      },
      {
        canActivate: [AuthGuard, InitialFormGuard],
        path: 'plans/templates/meal',
        component: MealPlanTemplatesComponent,
      },
      {
        canActivate: [AuthGuard, InitialFormGuard],
        canDeactivate: [PendingChangesGuard],
        path: 'Template/:id',
        component: MealPlanDefComponent,
        resolve: { templateData: MealPlanTemplateResolver },
      },
      {
        canActivate: [AuthGuard, InitialFormGuard],
        path: 'MealPlan/:PatientId',
        component: MealViewerComponent,
      },
      {
        canActivate: [AuthGuard, InitialFormGuard],
        canDeactivate: [PendingChangesGuard],
        path: 'MealPlanEdit/:planId',
        component: EditMealPlanDefComponent,
      },
      {
        canActivate: [AuthGuard, InitialFormGuard],
        path: 'PatientMealPlan/:PatientId/:PlanId',
        component: MealViewerComponent,
      },
      {
        canActivate: [AuthGuard, InitialFormGuard],
        canDeactivate: [PendingChangesGuard],
        path: 'NewPlan/:PatientId',
        component: AddMealPlanDefComponent,
      },
      {
        canActivate: [AuthGuard, InitialFormGuard],
        canDeactivate: [PendingChangesGuard],
        path: 'NewPlan/:PatientId/FromTutorial',
        component: AddMealPlanDefComponent,
      },
      {
        canActivate: [AuthGuard, InitialFormGuard],
        path: 'manage-subscription',
        component: SubscriptionPlanComponent,
      },
      {
        canActivate: [AuthGuard, InitialFormGuard],
        canDeactivate: [PendingChangesGuard],
        path: 'NewFitnessPlan/:PatientId',
        component: AddFitnessPlanDefComponent,
      },
      {
        canActivate: [AuthGuard, InitialFormGuard],
        canDeactivate: [PendingChangesGuard],
        path: 'NewFitnessPlan/:PatientId/FromTutorial',
        component: AddFitnessPlanDefComponent,
      },

      {
        canActivate: [AuthGuard, InitialFormGuard],
        canDeactivate: [PendingChangesGuard],
        path: 'FitnessPlanEdit/:PlanId',
        component: EditFitnessPlanDefComponent,
      },
      {
        canActivate: [AuthGuard, InitialFormGuard],
        path: 'plans/templates/fitness',
        component: FitnessPlanTemplatesComponent,
      },
      {
        canActivate: [AuthGuard, InitialFormGuard],
        canDeactivate: [PendingChangesGuard],
        path: 'FitnessTemplate/:id',
        component: FitnessPlanDefComponent,
        resolve: { templateData: FitnessPlanTemplateResolver },
      },
      {
        canActivate: [AuthGuard, InitialFormGuard],
        path: 'my-exercise',
        component: CustomExerciseListComponent,
      },
      {
        canActivate: [AuthGuard],
        path: 'brand',
        component: BrandComponent,
      },
      {
        canActivate: [AuthGuard],
        path: 'help',
        component: HelpGuidesComponent,
      },
      {
        canActivate: [AuthGuard],
        path: 'Billing',
        component: BillingComponent,
      },
      {
        canActivate: [AuthGuard],
        path: 'program-template',
        component: ProgramTemplatesComponents,
      },
      {
        canActivate: [AuthGuard],
        path: 'program-template/:id',
        component: ProgramTemplateEditComponent,
      },
      {
        canActivate: [AuthGuard],
        path: 'program-template/meal/:programTemplateId/:planIndex',
        component: MealPlanDefComponent,
      },
      {
        canActivate: [AuthGuard],
        path: 'program-template/fitness/:programTemplateId/:planIndex',
        component: FitnessPlanDefComponent,
      },
      {
        canActivate: [AuthGuard],
        path: 'settings',
        component: AssessmentSettingComponent,
      }
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [GoalFormResolverModule],
})
export class CalorieFriendRoutingModule {}
